// extracted by mini-css-extract-plugin
module.exports = {"listings":"styles_listings__XUx4j","items":"styles_items__d9FWX","pagination":"styles_pagination__UghgL","page_counter":"styles_page_counter__xkncr"};